import { linuxVM, awsLinuxVM, sqlPaaS, windowsVM, oracleIaaS, sqlIaaS, storageBlog, aksNS, getRetentionPeriod } from 'utils';
import { getRetentionData } from 'utils/getRetentionData';
import {
    keyvaultCatalogDefinitionId,
    kafkaCatalogDefinitionId,
    AlbCatalogDefinitionId,
    eventhubDefinitionId,
    linuxSLESCatalogDefinitionId,
    SlesPgtCatalogDefinitionId,
    PgtSapSolutionCatalogDefinitionId,
    pECatalogDefinitionId,
    NsgAutomationRulesProvisioningCatalogDefinitionID,
    eipStackCatalogDefinitionId,
    adfCatalogDefinitionId,
    couchbaseDbDefinitionId,
    ApplicationGateWayURLCatalogDefinitionID,
    InternalApplicationGateWayURLCatalogDefinitionID,
    ExternalPublicLoadBalancerURLCatalogDefinitionID,
    linuxOELCatalogDefinitionId,
    windowsCatalogDefinitionId,
    sqlIaaSCatalogDefinitionId,
    linuxCatalogDefinitionId,
    oracleIaaSDefinitionId,
    oelOracleCatalogDefinitionId,
    NewInternalApplicationGateWayProvisioningCatalogDefinitionID,
    SlesPgtDBCatalogDefinitionId,
    CloudOnboardingCatalogDefinitionID,
    pgcsSqlIaaSCatalogDefinitionId,
    edapAksCatalogDefinitionId,
    pgcsWindowsVmCatalogDefinitionId,
    AwsEC2CatalogDefinitionId,
    AwsRHELCatalogDefinitionId,
    AwsRHELCBCatalogDefinitionId,
    AwsSLESCatalogDefinitionId,
    AwsOracleRDSCatalogDefinitionId,
    AwsS3BucketCatalogDefinitionId,
    AwsOELCatalogDefinitionId,
    AwsSQLRDSCatalogDefinitionId,
    AwsMYSQLRDSCatalogDefinitionId,
    AwsPostgresqlCatalogDefinitionId,
    AwsDynamoDbCatalogDefinitionId,
    AwsSQLIaasCatalogDefinitionId,
    AwsOracle19CCatalogDefinitionId,
    AwsNLBCatalogDefinitionId,
    AwsExternalNLBCatalogDefinitionId,
    AwsALBCatalogDefinitionId,
    PostgreSQLFlexibleDbCatalogDefinitionId,
    MySQLFlexibleDbCatalogDefinitionId,
    AwsCloudOnboardingCatalogDefinitionId,
    AwsAccountVendingCatalogDefinitionId,
    AwsInternalUrlOnboardingCatalogDefinitionId,
    AwsExternalURLOnboardingCatalogDefinitionId,
    AwsEksnCatalogDefinitionId,
    CosmosDbCatalogDefinitionId,
    AwsLexCatalogDefinitionId,
    AwsSNSCatalogDefinitionId,
    PCWindowsCatalogDefinitionId,
    AwsLambdaFunctionCatalogDefinitionId,
    PCLinuxCatalogDefinitionId,
    PCSQLIaasCatalogDefinitionId,
    PCOracleDBCatalogDefinitionId,
    EDAPAzureNodePoolCatalogDefinitionId,
    AwsKafkaTopicCatalogDefinitionId,
    AzCBVMCatalogDefinitionId,
    AwsSQSCatalogDefinitionId,
    AzureOracleExadataCatalogDefinitionId,
    AwsDocumentDBCatalogDefinitionId,
} from 'utils/catalogDefinitionId';
import { getKafkaOrderSummary } from './getKafkaSummary';
import { getNewInternalAppGatewaySummary } from './getNewInternalAppGatewaySummary';
import { getInternalAppGatewaySummary } from './getInternalAppGatewaySummary';
import { getExternalPublicLoadBalancerSummary } from './getExternalPublicLoadBalancerSummary';
import { getCloudOnboardingSummary } from './getCloudOnboardingSummary';
import { addPropertyIfExists, addBooleanPropertyIfExists } from './orderSummaryUtils';

export const getOrderSummary = ({ orders = [] }) => {
    const getServiceResourceTags = (components) => {
        const serviceResourceTags = {};
        const catalogShortName = {
            CFKAFKA: 'Kafka',
            AZSQLPAAS: 'SQL',
            AZAKSNS: 'AKS',
            AZSTORAGE: 'Storage Account',
        };
        components.map((x) => {
            serviceResourceTags[`${catalogShortName[x?.catalogService?.catalogConfig?.type]} Servicename`] =
                x?.catalogService?.catalogConfig?.tags?.Servicename;
            return serviceResourceTags;
        });
        return serviceResourceTags;
    };
    if (orders?.catalogServices && orders?.catalogServices.length) {
        const result = orders?.catalogServices?.map((item) => {
            const orderItemDetails = {
                orderId: orders?.id,
                createdByGpId: orders?.created?.by?.id,
                catalogType: item?.catalogType,
                catalogServiceId: item?.catalogServiceId,
                catalogServiceCode: item?.catalogServiceCode,
                quantity: item?.quantity,
                orderStatus: orders?.currentStatus?.status,
                osType: null,
                summary: {},
                eventHubDetails: [],
                dataDisks: [],
                environmentDetails: {},
                selectedNetworks: [],
                tags: {},
                applicationDetails: {},
                questionnaireResponses: item?.catalogConfig?.questionnaireResponses || {},
                ...([
                    ...ApplicationGateWayURLCatalogDefinitionID,
                    ...InternalApplicationGateWayURLCatalogDefinitionID,
                    ...ExternalPublicLoadBalancerURLCatalogDefinitionID,
                    ...CloudOnboardingCatalogDefinitionID,
                    ...PostgreSQLFlexibleDbCatalogDefinitionId,
                    ...MySQLFlexibleDbCatalogDefinitionId,
                    ...AwsCloudOnboardingCatalogDefinitionId,
                    ...AwsAccountVendingCatalogDefinitionId,
                ]?.includes(item.catalogServiceCode) && {
                    provisionDetails: {},
                }),
            };
            orderItemDetails.summary = {
                ...([
                    ...AwsEC2CatalogDefinitionId,
                    ...AwsRHELCatalogDefinitionId,
                    ...AwsRHELCBCatalogDefinitionId,
                    ...AwsSLESCatalogDefinitionId,
                    ...AwsOracleRDSCatalogDefinitionId,
                    ...AwsS3BucketCatalogDefinitionId,
                    ...AwsSQLRDSCatalogDefinitionId,
                    ...AwsMYSQLRDSCatalogDefinitionId,
                    ...AwsOELCatalogDefinitionId,
                    ...AwsPostgresqlCatalogDefinitionId,
                    ...AwsDynamoDbCatalogDefinitionId,
                    ...AwsSQLIaasCatalogDefinitionId,
                    ...AwsOracle19CCatalogDefinitionId,
                    ...AwsNLBCatalogDefinitionId,
                    ...AwsALBCatalogDefinitionId,
                    ...PostgreSQLFlexibleDbCatalogDefinitionId,
                    ...MySQLFlexibleDbCatalogDefinitionId,
                    ...AwsInternalUrlOnboardingCatalogDefinitionId,
                    ...AwsExternalURLOnboardingCatalogDefinitionId,
                    ...AwsLambdaFunctionCatalogDefinitionId,
                    ...CosmosDbCatalogDefinitionId,
                    ...AwsLexCatalogDefinitionId,
                    ...AwsSNSCatalogDefinitionId,
                    ...AwsKafkaTopicCatalogDefinitionId,
                    ...AwsDocumentDBCatalogDefinitionId,
                ].includes(item.catalogServiceCode) && {
                    ...addPropertyIfExists(item.catalogConfig?.applicationService, 'Application Service'),
                    ...addPropertyIfExists(item?.sector, 'Sector'),
                    ...addPropertyIfExists(item?.catalogConfig?.department, 'Department'),
                    ...addPropertyIfExists(item?.catalogConfig?.environment, 'Environment'),
                    ...addPropertyIfExists(item?.catalogConfig?.region, 'Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationRegion, 'Application Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.awsRegion, 'Aws Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.costCenter, 'Cost Center'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.environment, 'Environment'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.region, 'Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.applicationRegion, 'Application Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.department, 'Department'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationName, 'Application Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.appShortName, 'App Short Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationShortName, 'App Short Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.costCenter, 'Cost Center'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.projectName, 'Project Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.applicationTier, 'Application Tier'),
                    ...addPropertyIfExists(item?.catalogConfig?.albConfiguration?.albName, 'Alb Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.albConfiguration?.albType, 'Load Balancer Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.nlbConfiguration?.nlbName, 'Nlb Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.nlbConfiguration?.nlbType, 'Load Balancer Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.accountId, 'Account ID'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.highAvailability, 'High Availability'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.edrsEnabled, 'EDRS Enabled'),
                    ...addPropertyIfExists(item?.catalogConfig?.tableName, 'Table Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.tableClassName, 'Table Class'),
                    ...addPropertyIfExists(item?.catalogConfig?.partitionKey, 'Partition Key'),
                    ...addPropertyIfExists(item?.catalogConfig?.partitionKeyType, 'Partition Key Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.sortKey, 'Sort Key'),
                    ...addPropertyIfExists(item?.catalogConfig?.sortKeyType, 'Sort Key Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.capacityMode, 'Capacity Mode'),
                    ...addPropertyIfExists(item?.catalogConfig?.onDemandReadRequests, 'Read Capacity Units'),
                    ...addPropertyIfExists(item?.catalogConfig?.onDemandWriteRequests, 'Write Capacity Units'),
                    ...addPropertyIfExists(item?.catalogConfig?.encryption, 'Encryption'),
                    ...addPropertyIfExists(item?.catalogConfig?.timeToLive, 'Time to Live (TTL)'),
                    ...addPropertyIfExists(item?.catalogConfig?.ttlAttribute, 'TTL Attribute'),
                    ...([...AwsRHELCBCatalogDefinitionId].includes(item.catalogServiceCode) &&
                        addPropertyIfExists(item?.catalogConfig?.customBuildType, 'Custom Build Type')),
                    ...addPropertyIfExists(item?.catalogConfig?.osImage, 'OS Image'),
                    ...addPropertyIfExists(item?.catalogConfig?.vpcId, 'VPC ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.awsAccountName, 'Aws Account Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.awsAccountId, 'Aws Account ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.vpcName, 'VPC Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.vpcId, 'VPC ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.availabilityZone, 'Availability Zone'),
                    ...addPropertyIfExists(item?.catalogConfig?.collation, 'Server Collation'),
                    ...addPropertyIfExists(item?.catalogConfig?.dbInstanceType, 'DB Instance Type'),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.availabilityZone)
                            ? item?.catalogConfig?.availabilityZone.join(', ')
                            : item?.catalogConfig?.availabilityZone,
                        'Availability Zone'
                    ),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.environmentDetails?.subnetDetails)
                            ? item?.catalogConfig?.environmentDetails?.subnetDetails.map((subnet) => subnet.name).join(', ')
                            : item?.catalogConfig?.environmentDetails?.subnetDetails,
                        'Subnet Details'
                    ),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.subnetId) ? item?.catalogConfig?.subnetId.join(', ') : item?.catalogConfig?.subnetId,
                        'Subnet ID'
                    ),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbName, 'ALB Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.albRuleName, 'ALB Rule Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbArn, 'ALB ARN'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalNlbName, 'NLB Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalNlbArn, 'NLB ARN'),
                    ...addPropertyIfExists(item?.catalogConfig?.albConfguration?.albName, 'ALB Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.albConfguration?.albType, 'ALB Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.nlbConfguration?.nlbName, 'NLB Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.nlbConfguration?.nlbType, 'NLB Type'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.nlbConfguration?.crossZone, 'Cross Zone Load Balancing', 'Enabled', 'Disabled'),
                    ...addPropertyIfExists(item?.catalogConfig?.targetGroups?.name, 'Target Name'),
                    ...addPropertyIfExists(
                        item?.catalogConfig?.eksRequired,
                        'Do you require EKS Pattern?',
                        item?.catalogConfig?.eksRequired === 'yes' ? 'Yes' : 'No'
                    ),
                    ...addPropertyIfExists(item?.catalogConfig?.targetGroups?.targetType, 'Target Type'),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.targetGroups?.ips)
                            ? item?.catalogConfig?.targetGroups?.ips.join(', ')
                            : item?.catalogConfig?.targetGroups?.ips,
                        'Target EKS-Ingress IP Address'
                    ),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.targetGroups?.instanceId)
                            ? item?.catalogConfig?.targetGroups?.instanceId.join(', ')
                            : item?.catalogConfig?.targetGroups?.instanceId,
                        'Target Instance IDs'
                    ),
                    ...addPropertyIfExists(item?.catalogConfig?.targetGroups?.protocol, 'Target Protocol'),
                    ...addPropertyIfExists(item?.catalogConfig?.targetGroups?.port, 'Target Port'),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.targetGroups?.instanceName)
                            ? item?.catalogConfig?.targetGroups?.instanceName.join(', ')
                            : item?.catalogConfig?.targetGroups?.instanceName,
                        'Target Instance Name'
                    ),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.name, 'ALB Target Group Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalNlbTargetGroupName, 'NLB Target Group Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.targetType, 'Target Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.protocol, 'Target Protocol'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.port, 'Target Port'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.crossOriginRequired, 'Cross Origin Required', 'Yes', 'No'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.crossAppProfile, 'Shared Platform Application Service'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.crossSector, 'Shared Platform Sector'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.crossDepartment, 'Shared Platform Department'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.crossRegion, 'Shared Platform Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.crossAccount, 'Shared Platform  AWS Account Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.crossAccountId, 'Shared Platform AWS Account ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalAlbTargetGroup?.ip?.join(', '), 'Target Instance IP Addresses'),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.internalAlbTargetInstanceIds)
                            ? item?.catalogConfig?.internalAlbTargetInstanceIds.join(', ')
                            : item?.catalogConfig?.internalAlbTargetInstanceIds,
                        'Target Instance IDs'
                    ),
                    ...addPropertyIfExists(item?.catalogConfig?.listeners?.port, 'Listeners Port'),
                    ...addPropertyIfExists(item?.catalogConfig?.listeners?.protocol, 'Listeners Protocol'),
                    ...addPropertyIfExists(item?.catalogConfig?.healthCheck?.protocol, 'Health Check Protocol'),
                    ...addPropertyIfExists(item?.catalogConfig?.healthCheck?.path, 'Health Check Path'),
                    ...addPropertyIfExists(item?.catalogConfig?.healthCheck?.port, 'Health Check Port'),
                    ...addPropertyIfExists(item?.catalogConfig?.healthCheck?.timeout, 'Idle Timeout'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationUrl, 'Application Url'),
                    ...addPropertyIfExists(item?.catalogConfig?.appSupportMailId, 'Application Support DL'),
                    ...addPropertyIfExists(item?.catalogConfig?.activeDirectoryCertificateGroup, 'AD Group'),
                    ...addPropertyIfExists(item?.catalogConfig?.supportBackendCertificate, 'Support  Backend  Certificate'),
                    ...addPropertyIfExists(item?.catalogConfig?.securityGroup, 'Security Group'),
                    ...addPropertyIfExists(item?.catalogConfig?.instanceType, 'Instance Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.timeZone, 'Timezone'),
                    ...addPropertyIfExists(item?.catalogConfig?.billingEntity, 'Billing Entity'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.serverRefresh, 'serverRefresh'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.haDeployment, 'HA Deployment'),
                    ...(item?.catalogConfig?.serverRefresh === true && {
                        ...addPropertyIfExists(item?.catalogConfig?.retiringServerName, 'Retiring Server Name'),
                        ...addPropertyIfExists(item?.catalogConfig?.scheduledRetirement, 'Scheduled Retirement Date'),
                        ...addPropertyIfExists(item?.catalogConfig?.disposalReason, 'Disposal Reason'),
                    }),
                    ...addPropertyIfExists(item?.catalogConfig?.domain, 'Domain'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.domain, 'Domain'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.adOu, 'AD OU'),
                    ...addPropertyIfExists(item?.catalogConfig?.sqlVersion, 'SQL Version'),
                    ...addPropertyIfExists(item?.catalogConfig?.oracleVersion, 'Oracle Version'),
                    ...addPropertyIfExists(item?.catalogConfig?.dbCharacterSet, 'Database Character Set'),
                    ...addPropertyIfExists(item?.catalogConfig?.dbNationalCharSet, 'Database National Character Set'),
                    ...addPropertyIfExists(item?.catalogConfig?.services?.join(', '), 'Services'),
                    ...addPropertyIfExists(item?.catalogConfig?.dbSize && `${item?.catalogConfig?.dbSize} GB`, 'Storage Size'),
                    ...addPropertyIfExists(item?.catalogConfig?.sqlServerCollation, 'Server Collation'),
                    ...addPropertyIfExists(item?.catalogConfig?.adGroup, 'AD Group'),
                    ...addPropertyIfExists(item?.catalogConfig?.adGroups && item?.catalogConfig?.adGroups.join(', '), 'AD Group'),
                    ...(!AwsLambdaFunctionCatalogDefinitionId.includes(item.catalogServiceCode) &&
                        addPropertyIfExists(item?.catalogConfig?.awsAccountId, 'Account ID')),
                    ...addPropertyIfExists(item?.catalogConfig?.dbSubnetGroupName, 'Database Subnet Group'),
                    ...addPropertyIfExists(
                        item?.catalogConfig?.rdsInstanceId,
                        (AwsOracleRDSCatalogDefinitionId.includes(item.catalogServiceCode) && 'Oracle RDS Instance Name') ||
                            (AwsSQLRDSCatalogDefinitionId.includes(item.catalogServiceCode) && 'SQL RDS Instance Name') ||
                            (AwsMYSQLRDSCatalogDefinitionId.includes(item.catalogServiceCode) && 'MySQL RDS Instance Name') ||
                            (AwsPostgresqlCatalogDefinitionId.includes(item.catalogServiceCode) && 'PostgreSQL RDS Instance Name')
                    ),
                    ...addPropertyIfExists(
                        item?.catalogConfig?.engine,
                        (AwsOracleRDSCatalogDefinitionId.includes(item.catalogServiceCode) && 'Oracle Database Edition') ||
                            (AwsSQLRDSCatalogDefinitionId.includes(item.catalogServiceCode) && 'SQL Database Edition') ||
                            (AwsMYSQLRDSCatalogDefinitionId.includes(item.catalogServiceCode) && 'MySQL Database Edition') ||
                            (AwsPostgresqlCatalogDefinitionId.includes(item.catalogServiceCode) && 'PostgreSQL Database Edition')
                    ),
                    ...addPropertyIfExists(
                        item?.catalogConfig?.databaseVersion,
                        (AwsOracleRDSCatalogDefinitionId.includes(item.catalogServiceCode) && 'Oracle Database Version') ||
                            (AwsSQLRDSCatalogDefinitionId.includes(item.catalogServiceCode) && 'SQL Database Version') ||
                            (AwsMYSQLRDSCatalogDefinitionId.includes(item.catalogServiceCode) && 'MySQL Database Version') ||
                            (AwsPostgresqlCatalogDefinitionId.includes(item.catalogServiceCode) && 'PostgreSQL Database Version')
                    ),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.sqlDatabaseAuthentication, 'SQL Database Authentication', 'Yes', 'No'),
                    ...addPropertyIfExists(item?.catalogConfig?.sqlAccountName, 'SQL Account Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.dbInstanceClass, 'Database Instance Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.storageType, 'Storage Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.allocatedStorage, 'Expected Storage Size'),
                    ...addPropertyIfExists(item?.catalogConfig?.dbName, 'Database Name'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.containerDbRequired, 'Is Container DB Required'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.multiTenantRequired, 'Is Multi Tenant Required'),
                    ...addPropertyIfExists(
                        item?.catalogConfig?.multiTenantDbNames && item?.catalogConfig?.multiTenantDbNames.join(', '),
                        'Multi Tenant DB Names'
                    ),
                    ...addPropertyIfExists(item?.catalogConfig?.bucketName, 'S3 Bucket Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.storageClass, 'Storage Class'),
                    ...addPropertyIfExists(item?.catalogConfig?.serverSideEncryption, 'Server Side Encryption'),
                    ...addPropertyIfExists(item?.catalogConfig?.s3BucketUsedBy, 'Application Support Team Name'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.isS3BucketKeyEnabled, 'S3 Bucket Key Enabled'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.isVersioningEnabled, 'Versioning'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.isBucketFolderRequired, 'Is S3 Bucket Folder Required'),
                    ...addPropertyIfExists(item?.catalogConfig?.bucketFolder && item?.catalogConfig?.bucketFolder.join(', '), 'S3 Folder Names'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.isBlockPublicAccessEnabled, 'S3 Bucket Public Access'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.isS3ObjectLockEnabled, 'S3 Object Lock Enabled'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.isBlockPublicAccessEnabled, 'S3 Bucket Public Access'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.isReplication, ' S3 Bucket Cross Region Replication'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.replicationCrossRegion, 'S3 Bucket Replication Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.replicationBucketName, 'S3 Bucket Replication Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.resourceGroup, 'Resource Group'),
                    ...addPropertyIfExists(item?.catalogConfig?.subscription, 'Subscription'),
                    ...addPropertyIfExists(item?.catalogConfig?.postgresqlName, 'PostgreSql Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.mysqlName, 'MySql Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.supportedFlexibleServerEditions, 'Supported Flexible Server Editions'),
                    ...addPropertyIfExists(item?.catalogConfig?.skuName, 'Sku Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.version, 'Version'),
                    ...addPropertyIfExists(item?.catalogConfig?.storageMB, 'Storage Size (GB)'),
                    ...addPropertyIfExists(item?.catalogConfig?.databases, 'Databases'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.highAvailability, 'High Availability'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.highAvailabilityEnabled, 'High Availability'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.autoGrowEnabled, 'Auto Grow Enabled'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.nlbConfiguration?.crossZone, 'Cross Zone'),
                    ...addPropertyIfExists(item?.catalogConfig?.componentName, 'Application Security Group Component Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.securityGroupName, 'Security Group Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.securityGroupId, 'Security Group Id'),
                    ...addPropertyIfExists(item?.catalogConfig?.botName, 'Bot Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.botPrefix, 'Bot Prefix'),
                    ...addPropertyIfExists(item?.catalogConfig?.botDescription, 'Bot Description'),
                    ...addPropertyIfExists(item?.catalogConfig?.creationMethod, 'Creation Method'),
                    ...addPropertyIfExists(item?.catalogConfig?.locale, 'Locale ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.voiceId, 'Voice ID'),
                    ...(!AwsLambdaFunctionCatalogDefinitionId.includes(item.catalogServiceCode) &&
                        addPropertyIfExists(item?.catalogConfig?.timeout, 'Session Timeout')),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.ischildDirected, 'COPPA Compliant (Child Directed)'),
                    // Cosmos
                    ...addPropertyIfExists(item?.catalogConfig?.apiType, 'API Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.geoReplica, 'Geo Replication'),
                    ...addPropertyIfExists(item?.catalogConfig?.gmsaServiceAccount, 'GMSA Service Account'),
                    ...addPropertyIfExists(item?.catalogConfig?.gmsaComputerGroup, 'GMSA Computer Group'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosNoSql?.sqlDbAccountName, 'Database Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosMongoDB?.mongoDbAccountName, 'Database Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosMongoDB?.mongoDbResourceType, 'Resource Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosMongoDB?.mongoDbVersion, 'Version'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosMongoDB?.mongoDbClusterTier, 'Cluster Tier'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosMongoDB?.mongoDbClusterSize, 'Cluster Size'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosMongoDB?.mongoDbClusterStorage, 'Cluster Storage'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosPostgreSQL?.postgreSQLDbAccountName, 'Database Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosPostgreSQL?.postgreSQLVersion, 'Postgres Version'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosPostgreSQL?.postgreSQLDbNodeCount, 'Node Count'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosPostgreSQL?.postgreSQLDbNodeStorage, 'Node Storage'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosPostgreSQL?.postgreSQLDbNodeCompute, 'Node Compute'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.cosmosPostgreSQL?.isHighAvailabilityEnabled, 'High Availability'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosPostgreSQL?.availabilityZones, 'Availability Zones'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosApacheGremlin?.gremlinDbAccountName, 'Database Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosApacheCassandra?.cassandraDbAccountName, 'Database Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.cosmosTable?.tableDbAccountName, 'Database Name'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.roleAssignmentRequired, 'Role Assignment Required'),
                    ...(Array.isArray(item?.catalogConfig?.readableAdGroupNames) && {
                        ...addBooleanPropertyIfExists(item?.catalogConfig?.isNonPriviledgedAdgroup, 'Do you have a Non-Privileged Active Directory Group?'),
                    }),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.readableAdGroupNames)
                            ? item?.catalogConfig?.readableAdGroupNames.join(', ')
                            : item?.catalogConfig?.readableAdGroupNames,
                        'Non-Privileged Groups'
                    ),
                    ...addPropertyIfExists(item?.quantity, 'Quantity'),
                }),
                // Aws DocumentDB
                ...addPropertyIfExists(item?.catalogConfig?.documentDbClusterIdentifier, 'Document DB Cluster Identifier'),
                ...addPropertyIfExists(item?.catalogConfig?.clusterType, 'Cluster Type'),
                ...addBooleanPropertyIfExists(item?.catalogConfig?.enableGlobalCluster, 'Enable Global Cluster'),
                ...addPropertyIfExists(item?.catalogConfig?.globalClusterIdentifier, 'Global Cluster Identifier'),
                ...addPropertyIfExists(item?.catalogConfig?.secondaryRegion, 'Secondary Region'),
                ...addPropertyIfExists(item?.catalogConfig?.engineVersion, 'Engine Version'),
                ...addPropertyIfExists(item?.catalogConfig?.instanceClass, 'Instance Class'),
                ...addPropertyIfExists(item?.catalogConfig?.minCapacityDcus, 'Minimum Capacity DCUs'),
                ...addPropertyIfExists(item?.catalogConfig?.maxCapacityDcus, 'Maximum Capacity DCUs'),
                ...addPropertyIfExists(item?.catalogConfig?.instanceCount, 'Number of Instances'),
                ...addPropertyIfExists(item?.catalogConfig?.initialStorageSize, 'Initial Storage (GB)'),
                ...addPropertyIfExists(item?.catalogConfig?.shardCount, 'Shard Count'),
                ...addPropertyIfExists(item?.catalogConfig?.instancesPerShard, 'Instances Per Shard'),
                ...addPropertyIfExists(item?.catalogConfig?.vCpusPerShard, 'VCPUs Per Shard'),
                ...(kafkaCatalogDefinitionId.includes(item.catalogServiceCode) && getKafkaOrderSummary(item)),
                ...(AzCBVMCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    catalog: `${item?.catalogConfig?.os?.osType}, ${item?.catalogConfig?.os?.sku}`,
                    'OS Type': item?.catalogConfig?.os?.osType,
                    'OS Image': item?.catalogConfig?.os?.sku,
                    'Build Type': item?.catalogConfig?.buildType,
                    'VM Type': item?.catalogConfig?.vmType,
                    domain: item?.catalogConfig?.environmentDetails?.domain,
                    ...(item?.catalogConfig?.environmentDetails?.environment === 'Production' && {
                        'Azure Site Recovery': item?.catalogConfig?.azureSiteRecovery ? 'Yes' : 'No',
                    }),
                    ...(item?.catalogConfig?.os?.osType?.toLowerCase() === 'linux' &&
                        item?.catalogConfig?.samAccountId && {
                            'SAM Account ID': item?.catalogConfig?.samAccountId,
                        }),
                    ...(item?.catalogConfig?.os?.osType?.toLowerCase() !== 'linux' && {
                        'AD OU': item?.catalogConfig?.environmentDetails?.adOu,
                        'AD Group': item?.catalogConfig?.adGroup,
                    }),
                    'OS Timezone': item?.timeZone,
                    'Accelerated Networking Enabled': `${item?.catalogConfig?.acceleratedNetworking === true ? 'Yes' : 'No'}`,
                }),
                ...(AwsKafkaTopicCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    catalog: item?.catalogType,
                    ...addPropertyIfExists(item?.catalogConfig?.appOwner, 'Application Owner ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.topicName, 'Topic Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.project, 'Project'),
                    ...addPropertyIfExists(item?.catalogConfig?.partitionCount, 'Partitions'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.businessUnit, 'Business Unit'),
                    ...addPropertyIfExists(
                        item?.catalogConfig?.retentionUnit
                            ? getRetentionPeriod(item?.catalogConfig?.retentionPeriod, item?.catalogConfig?.retentionUnit)
                            : getRetentionData(item?.catalogConfig?.retentionPeriod),
                        'Retention Period'
                    ),
                    ...addPropertyIfExists(item?.catalogConfig?.cluster, 'Cluster'),
                    ...addPropertyIfExists(item?.catalogConfig?.size, 'Catalog Size'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.isaDocument, 'ISA Document'),
                    ...addPropertyIfExists(item?.catalogConfig?.ldapGroup, 'LDAP Group Name'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.producerId !== null, 'Write Access User'),
                    ...addPropertyIfExists(item?.catalogConfig?.producerId, 'Write Access User Name'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.isReadAccessRequired, 'Read Access Required'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.consumerId !== null, 'Read Access User'),
                    ...addPropertyIfExists(item?.catalogConfig?.consumerId, 'Read Access User Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.consumerGroup, 'Consumer Group'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.isTransactional, 'Transactional ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.transactionPrincipalId, 'Transaction Access User'),
                    ...addPropertyIfExists(item?.catalogConfig?.transactionPrefixText, 'Transaction ID Prefix'),
                }),
                ...((linuxVM.includes(item.catalogServiceCode) ||
                    windowsVM.includes(item.catalogServiceCode) ||
                    oracleIaaS.includes(item.catalogServiceCode) ||
                    sqlIaaS.includes(item.catalogServiceCode) ||
                    pgcsSqlIaaSCatalogDefinitionId.includes(item?.catalogServiceCode) ||
                    pgcsWindowsVmCatalogDefinitionId.includes(item?.catalogServiceCode)) && {
                    ...([
                        ...linuxOELCatalogDefinitionId,
                        ...linuxSLESCatalogDefinitionId,
                        ...SlesPgtCatalogDefinitionId,
                        ...SlesPgtDBCatalogDefinitionId,
                        ...PgtSapSolutionCatalogDefinitionId,
                    ].includes(item.catalogServiceCode) && {
                        catalog: item?.catalogType,
                    }),
                    ...(![
                        ...linuxOELCatalogDefinitionId,
                        ...linuxSLESCatalogDefinitionId,
                        ...SlesPgtCatalogDefinitionId,
                        ...SlesPgtDBCatalogDefinitionId,
                    ].includes(item.catalogServiceCode) && {
                        catalog: `${item.catalogConfig.os.publisher}, ${item.catalogConfig.os.sku}`,
                    }),
                    ...(oracleIaaS.includes(item.catalogServiceCode) && {
                        catalog: item?.catalogType,
                    }),
                }),
                ...([...storageBlog, ...aksNS, ...eventhubDefinitionId, ...eipStackCatalogDefinitionId].includes(item?.catalogServiceCode) && {
                    catalog: item?.catalogType,
                }),
                ...(![
                    ...storageBlog,
                    ...NewInternalApplicationGateWayProvisioningCatalogDefinitionID,
                    ...AwsEC2CatalogDefinitionId,
                    ...AwsRHELCatalogDefinitionId,
                    ...AwsRHELCBCatalogDefinitionId,
                    ...AwsSLESCatalogDefinitionId,
                    ...AwsS3BucketCatalogDefinitionId,
                    ...AwsOracleRDSCatalogDefinitionId,
                    ...AwsSQLRDSCatalogDefinitionId,
                    ...AwsMYSQLRDSCatalogDefinitionId,
                    ...AwsOELCatalogDefinitionId,
                    ...AwsPostgresqlCatalogDefinitionId,
                    ...AwsDynamoDbCatalogDefinitionId,
                    ...AwsSQLIaasCatalogDefinitionId,
                    ...AwsOracle19CCatalogDefinitionId,
                    ...AwsNLBCatalogDefinitionId,
                    ...AwsExternalNLBCatalogDefinitionId,
                    ...AwsALBCatalogDefinitionId,
                    ...PostgreSQLFlexibleDbCatalogDefinitionId,
                    ...MySQLFlexibleDbCatalogDefinitionId,
                    ...AwsInternalUrlOnboardingCatalogDefinitionId,
                    ...AwsExternalURLOnboardingCatalogDefinitionId,
                    ...AwsLambdaFunctionCatalogDefinitionId,
                    ...CosmosDbCatalogDefinitionId,
                    ...AwsLexCatalogDefinitionId,
                    ...AwsSNSCatalogDefinitionId,
                    ...AwsKafkaTopicCatalogDefinitionId,
                    ...PCWindowsCatalogDefinitionId,
                    ...PCLinuxCatalogDefinitionId,
                    ...PCSQLIaasCatalogDefinitionId,
                    ...PCOracleDBCatalogDefinitionId,
                    ...AwsSQSCatalogDefinitionId,
                    ...AzureOracleExadataCatalogDefinitionId,
                    ...AwsDocumentDBCatalogDefinitionId,
                ].includes(item.catalogServiceCode) &&
                    item?.sector && {
                        sector: item?.sector,
                    }),
                ...(![
                    ...ApplicationGateWayURLCatalogDefinitionID,
                    ...InternalApplicationGateWayURLCatalogDefinitionID,
                    ...NewInternalApplicationGateWayProvisioningCatalogDefinitionID,
                    ...CloudOnboardingCatalogDefinitionID,
                    ...AwsEC2CatalogDefinitionId,
                    ...AwsRHELCatalogDefinitionId,
                    ...AwsRHELCBCatalogDefinitionId,
                    ...AwsSLESCatalogDefinitionId,
                    ...AwsS3BucketCatalogDefinitionId,
                    ...AwsOELCatalogDefinitionId,
                    ...AwsSQLRDSCatalogDefinitionId,
                    ...AwsMYSQLRDSCatalogDefinitionId,
                    ...AwsOracleRDSCatalogDefinitionId,
                    ...AwsPostgresqlCatalogDefinitionId,
                    ...AwsDynamoDbCatalogDefinitionId,
                    ...AwsSQLIaasCatalogDefinitionId,
                    ...AwsOracle19CCatalogDefinitionId,
                    ...AwsNLBCatalogDefinitionId,
                    ...AwsExternalNLBCatalogDefinitionId,
                    ...AwsALBCatalogDefinitionId,
                    ...PostgreSQLFlexibleDbCatalogDefinitionId,
                    ...MySQLFlexibleDbCatalogDefinitionId,
                    ...AwsCloudOnboardingCatalogDefinitionId,
                    ...AwsAccountVendingCatalogDefinitionId,
                    ...AwsInternalUrlOnboardingCatalogDefinitionId,
                    ...AwsExternalURLOnboardingCatalogDefinitionId,
                    ...AwsLambdaFunctionCatalogDefinitionId,
                    ...CosmosDbCatalogDefinitionId,
                    ...AwsLexCatalogDefinitionId,
                    ...AwsSNSCatalogDefinitionId,
                    ...AwsKafkaTopicCatalogDefinitionId,
                    ...PCWindowsCatalogDefinitionId,
                    ...PCLinuxCatalogDefinitionId,
                    ...PCSQLIaasCatalogDefinitionId,
                    ...PCOracleDBCatalogDefinitionId,
                    ...AzureOracleExadataCatalogDefinitionId,
                    ...AwsDocumentDBCatalogDefinitionId,
                ]?.includes(item.catalogServiceCode) && {
                    environment: item?.catalogConfig?.environmentDetails?.environment,
                }),
                ...(![
                    ...aksNS,
                    ...kafkaCatalogDefinitionId,
                    ...AwsKafkaTopicCatalogDefinitionId,
                    ...eventhubDefinitionId,
                    ...eipStackCatalogDefinitionId,
                    ...adfCatalogDefinitionId,
                    ...AlbCatalogDefinitionId,
                    ...ApplicationGateWayURLCatalogDefinitionID,
                    ...InternalApplicationGateWayURLCatalogDefinitionID,
                    ...ExternalPublicLoadBalancerURLCatalogDefinitionID,
                    ...NewInternalApplicationGateWayProvisioningCatalogDefinitionID,
                    ...CloudOnboardingCatalogDefinitionID,
                    ...edapAksCatalogDefinitionId,
                    ...AwsEC2CatalogDefinitionId,
                    ...AwsRHELCatalogDefinitionId,
                    ...AwsRHELCBCatalogDefinitionId,
                    ...AwsSLESCatalogDefinitionId,
                    ...EDAPAzureNodePoolCatalogDefinitionId,
                    ...AwsEksnCatalogDefinitionId,
                    ...AwsOracleRDSCatalogDefinitionId,
                    ...AwsS3BucketCatalogDefinitionId,
                    ...AwsOELCatalogDefinitionId,
                    ...AwsSQLRDSCatalogDefinitionId,
                    ...AwsMYSQLRDSCatalogDefinitionId,
                    ...AwsPostgresqlCatalogDefinitionId,
                    ...AwsDynamoDbCatalogDefinitionId,
                    ...AwsSQLIaasCatalogDefinitionId,
                    ...AwsOracle19CCatalogDefinitionId,
                    ...AwsNLBCatalogDefinitionId,
                    ...AwsExternalNLBCatalogDefinitionId,
                    ...AwsALBCatalogDefinitionId,
                    ...PostgreSQLFlexibleDbCatalogDefinitionId,
                    ...MySQLFlexibleDbCatalogDefinitionId,
                    ...AwsCloudOnboardingCatalogDefinitionId,
                    ...AwsAccountVendingCatalogDefinitionId,
                    ...AwsInternalUrlOnboardingCatalogDefinitionId,
                    ...AwsExternalURLOnboardingCatalogDefinitionId,
                    ...AwsLambdaFunctionCatalogDefinitionId,
                    ...CosmosDbCatalogDefinitionId,
                    ...AwsLexCatalogDefinitionId,
                    ...AwsSNSCatalogDefinitionId,
                    ...PCWindowsCatalogDefinitionId,
                    ...PCLinuxCatalogDefinitionId,
                    ...PCSQLIaasCatalogDefinitionId,
                    ...PCOracleDBCatalogDefinitionId,
                    ...PgtSapSolutionCatalogDefinitionId,
                    ...AwsSQSCatalogDefinitionId,
                    ...AzureOracleExadataCatalogDefinitionId,
                    ...AwsDocumentDBCatalogDefinitionId,
                ].includes(item.catalogServiceCode) && {
                    'App Tier': item?.catalogConfig?.environmentDetails?.applicationTier,
                }),
                ...(![
                    ...ApplicationGateWayURLCatalogDefinitionID,
                    ...InternalApplicationGateWayURLCatalogDefinitionID,
                    ...NewInternalApplicationGateWayProvisioningCatalogDefinitionID,
                    ...CloudOnboardingCatalogDefinitionID,
                    ...AwsEC2CatalogDefinitionId,
                    ...AwsRHELCatalogDefinitionId,
                    ...AwsRHELCBCatalogDefinitionId,
                    ...AwsSLESCatalogDefinitionId,
                    ...AwsS3BucketCatalogDefinitionId,
                    ...AwsOELCatalogDefinitionId,
                    ...AwsSQLRDSCatalogDefinitionId,
                    ...AwsMYSQLRDSCatalogDefinitionId,
                    ...AwsOracleRDSCatalogDefinitionId,
                    ...AwsPostgresqlCatalogDefinitionId,
                    ...AwsDynamoDbCatalogDefinitionId,
                    ...AwsSQLIaasCatalogDefinitionId,
                    ...AwsOracle19CCatalogDefinitionId,
                    ...AwsNLBCatalogDefinitionId,
                    ...AwsExternalNLBCatalogDefinitionId,
                    ...AwsALBCatalogDefinitionId,
                    ...PostgreSQLFlexibleDbCatalogDefinitionId,
                    ...MySQLFlexibleDbCatalogDefinitionId,
                    ...AwsCloudOnboardingCatalogDefinitionId,
                    ...AwsAccountVendingCatalogDefinitionId,
                    ...AwsInternalUrlOnboardingCatalogDefinitionId,
                    ...AwsExternalURLOnboardingCatalogDefinitionId,
                    ...AwsLambdaFunctionCatalogDefinitionId,
                    ...CosmosDbCatalogDefinitionId,
                    ...AwsLexCatalogDefinitionId,
                    ...AwsSNSCatalogDefinitionId,
                    ...AwsKafkaTopicCatalogDefinitionId,
                    ...PCWindowsCatalogDefinitionId,
                    ...PCLinuxCatalogDefinitionId,
                    ...PCSQLIaasCatalogDefinitionId,
                    ...PCOracleDBCatalogDefinitionId,
                    ...AzureOracleExadataCatalogDefinitionId,
                    ...AwsDocumentDBCatalogDefinitionId,
                ]?.includes(item.catalogServiceCode) && {
                    region: item?.catalogConfig?.environmentDetails?.region,
                }),
                ...(sqlPaaS.includes(item?.catalogServiceCode) && {
                    'Server Collation': item?.catalogConfig?.azureSqlPurchase?.collation,
                    'Deployment Type': item?.catalogConfig?.deploymentType,
                    ...(item?.catalogConfig?.deploymentType === 'Elastic Pool' && {
                        'Elastic Pool Name': item?.catalogConfig?.elasticPool?.name || '-',
                    }),
                    'LogicalHost Name': item.catalogConfig.azureSqlPaasHost.name,
                    'SQL Database Name': item.catalogConfig.azureSqlPaasHost.dbName,
                    GeoReplication: item?.catalogConfig?.disasterRecovery === true || item?.catalogConfig?.geoReplication === true ? 'Yes' : 'No',
                    'SQL Database Authentication': item?.catalogConfig?.sqlDatabaseAuthentication === true ? 'Yes' : 'No',

                    ...(item?.catalogConfig?.applicationName && {
                        applicationName: item?.catalogConfig?.applicationName,
                    }),
                    ...(item?.catalogConfig?.applicationShortName && {
                        applicationShortName: item?.catalogConfig?.applicationShortName,
                    }),
                    ...(item?.catalogConfig?.sqlAccountName && {
                        'SQL Account Name': item?.catalogConfig?.sqlAccountName,
                    }),
                    ...(item?.catalogConfig?.disasterRecovery === true &&
                        item?.catalogConfig?.failOverGroupName &&
                        item?.catalogConfig?.secondaryServerName && {
                            secondaryServerName: item?.catalogConfig?.secondaryServerName,
                            failOverGroupName: item?.catalogConfig?.failOverGroupName,
                        }),
                    'Deployment Model': item.catalogConfig.azureSqlPaasHost.purchaseModel,
                    ...(item.catalogConfig.azureSqlPaasHost.purchaseModel === 'DTU' && {
                        'Service Tier': item.catalogConfig.azureSqlPurchase.sku.name,
                        type: item.catalogConfig.azureSqlPurchase.sku.tier,
                        capacity: item.catalogConfig.azureSqlPurchase.sku.capacity,
                    }),
                    ...(item.catalogConfig.azureSqlPaasHost.purchaseModel === 'vCore' && {
                        'Service Tier': item.catalogConfig.azureSqlPurchase.sku.tier,
                        'vCore Count': item.catalogConfig.azureSqlPurchase.sku.capacity,
                    }),
                    retention: `${item.catalogConfig.azureSqlRetention.days} Days`,
                    'Backup Interval': `${item.catalogConfig.azureSqlRetention.diffBackupInterval} Days`,
                    'Storage Size': `${item.catalogConfig.azureSqlPurchase.maxSizeBytes / (1024 * 1024 * 1024)} GB`,
                    zoneRedundancy: item?.catalogConfig?.zoneRedundancy === true ? 'Yes' : 'No',
                }),
                ...((linuxVM.includes(item.catalogServiceCode) ||
                    windowsVM.includes(item.catalogServiceCode) ||
                    oracleIaaS.includes(item.catalogServiceCode) ||
                    sqlIaaS.includes(item.catalogServiceCode) ||
                    pgcsSqlIaaSCatalogDefinitionId.includes(item?.catalogServiceCode) ||
                    pgcsWindowsVmCatalogDefinitionId.includes(item?.catalogServiceCode)) && {
                    ...([...linuxSLESCatalogDefinitionId, ...SlesPgtCatalogDefinitionId, ...SlesPgtDBCatalogDefinitionId].includes(item.catalogServiceCode) && {
                        OS: item?.catalogConfig?.os?.sku,
                    }),
                    'VM Type': item.catalogConfig.vmType,
                    'OS disk type': item.catalogConfig.os.osDiskType,
                    domain: item?.catalogConfig?.environmentDetails?.domain,
                    ...(item?.catalogConfig?.environmentDetails?.environment === 'Production' && {
                        'Azure Site Recovery': item.catalogConfig.azureSiteRecovery ? 'Yes' : 'No',
                    }),
                }),
                ...([...linuxVM, ...awsLinuxVM].includes(item.catalogServiceCode) &&
                    item.catalogConfig.samAccountId && {
                        'SAM Account ID': item.catalogConfig.samAccountId,
                    }),
                ...([...windowsVM, ...pgcsWindowsVmCatalogDefinitionId].includes(item.catalogServiceCode) && {
                    'AD OU': item?.catalogConfig?.environmentDetails?.adOu,
                    'AD Group': item?.catalogConfig?.adGroup,
                }),
                ...((sqlIaaS.includes(item?.catalogServiceCode) || pgcsSqlIaaSCatalogDefinitionId.includes(item?.catalogServiceCode)) && {
                    'Server Refresh': `${item?.catalogConfig?.serverRefresh === true ? 'Yes' : 'No'}`,
                    'AD OU': item?.catalogConfig?.environmentDetails?.adOu,
                }),
                ...((linuxVM.includes(item?.catalogServiceCode) ||
                    [...windowsVM, ...pgcsWindowsVmCatalogDefinitionId].includes(item?.catalogServiceCode) ||
                    oracleIaaS.includes(item?.catalogServiceCode) ||
                    sqlIaaS.includes(item?.catalogServiceCode) ||
                    pgcsSqlIaaSCatalogDefinitionId.includes(item?.catalogServiceCode)) && {
                    'OS Timezone': item?.timeZone,
                }),
                ...(storageBlog.includes(item?.catalogServiceCode) && {
                    'Cost Center': item?.catalogConfig?.environmentDetails?.costCenter,
                }),
                ...([...SlesPgtCatalogDefinitionId, ...SlesPgtDBCatalogDefinitionId, ...PgtSapSolutionCatalogDefinitionId]?.includes(
                    item?.catalogServiceCode
                ) && {
                    'SAP SID Name': item?.catalogConfig?.sapUserName,
                    'SAP GID Name': item?.catalogConfig?.sapGroupName,
                    ...(item?.catalogConfig?.sapUserId && {
                        'SAP UID': item?.catalogConfig?.sapUserId,
                    }),
                    ...(item?.catalogConfig?.sapAccountOwner && {
                        'SAP SID Account Owner': item?.catalogConfig?.sapAccountOwner?.name,
                    }),
                    ...(item?.catalogConfig?.sapGroupId && {
                        'SAP GID': item?.catalogConfig?.sapGroupId,
                    }),
                    Offer: item?.catalogConfig?.os?.offer,
                    'SAP Solution': item?.catalogConfig?.sapSolution,
                }),
                ...(PgtSapSolutionCatalogDefinitionId.includes(item?.catalogServiceCode) && {
                    'SAP Features': item?.catalogConfig?.sapFeatures?.join(', '),
                    'Cost Center': item?.catalogConfig?.environmentDetails?.costCenter,
                }),
                ...([...SlesPgtCatalogDefinitionId, ...SlesPgtDBCatalogDefinitionId]?.includes(item?.catalogServiceCode) && {
                    PacemakerClusterRequired: item?.catalogConfig?.pacemakerClusterRequired ? 'Yes' : 'No',
                }),
                ...([...SlesPgtCatalogDefinitionId, ...SlesPgtDBCatalogDefinitionId]?.includes(item?.catalogServiceCode) &&
                    item?.catalogConfig?.pacemakerClusterRequired && {
                        FQDNS: item?.catalogConfig?.fqdn,
                        ...(item?.catalogConfig?.sapEnvironment && { 'SAP Environment': item?.catalogConfig?.sapEnvironment }),
                    }),
                ...([...SlesPgtDBCatalogDefinitionId]?.includes(item?.catalogServiceCode) && {
                    dataBaseSize: item?.catalogConfig?.dataBaseSize,
                }),
                ...(AlbCatalogDefinitionId.includes(item?.catalogServiceCode) ||
                    ([...pECatalogDefinitionId, ...NsgAutomationRulesProvisioningCatalogDefinitionID].includes(item?.catalogServiceCode) &&
                        ![
                            ...ApplicationGateWayURLCatalogDefinitionID,
                            ...InternalApplicationGateWayURLCatalogDefinitionID,
                            ...ExternalPublicLoadBalancerURLCatalogDefinitionID,
                            ...NewInternalApplicationGateWayProvisioningCatalogDefinitionID,
                            ...CloudOnboardingCatalogDefinitionID,
                            ...AwsEC2CatalogDefinitionId,
                            ...AwsRHELCatalogDefinitionId,
                            ...AwsRHELCBCatalogDefinitionId,
                            ...AwsSLESCatalogDefinitionId,
                            ...AwsOELCatalogDefinitionId,
                            ...AwsSQLRDSCatalogDefinitionId,
                            ...AwsMYSQLRDSCatalogDefinitionId,
                            ...AwsOracleRDSCatalogDefinitionId,
                            ...AwsPostgresqlCatalogDefinitionId,
                            ...AwsS3BucketCatalogDefinitionId,
                            ...AwsDynamoDbCatalogDefinitionId,
                            ...AwsSQLIaasCatalogDefinitionId,
                            ...AwsOracle19CCatalogDefinitionId,
                            ...AwsNLBCatalogDefinitionId,
                            ...AwsExternalNLBCatalogDefinitionId,
                            ...AwsALBCatalogDefinitionId,
                            ...PostgreSQLFlexibleDbCatalogDefinitionId,
                            ...MySQLFlexibleDbCatalogDefinitionId,
                            ...AwsCloudOnboardingCatalogDefinitionId,
                            ...AwsAccountVendingCatalogDefinitionId,
                            ...AwsInternalUrlOnboardingCatalogDefinitionId,
                            ...AwsExternalURLOnboardingCatalogDefinitionId,
                            ...AwsLexCatalogDefinitionId,
                            ...AwsSNSCatalogDefinitionId,
                            ...AwsLambdaFunctionCatalogDefinitionId,
                            ...PCWindowsCatalogDefinitionId,
                            ...PCLinuxCatalogDefinitionId,
                            ...PCSQLIaasCatalogDefinitionId,
                            ...PCOracleDBCatalogDefinitionId,
                            ...AwsDocumentDBCatalogDefinitionId,
                            ...AwsSQSCatalogDefinitionId,
                        ]?.includes(item?.catalogServiceCode) && {
                            'Cost Center': item?.catalogConfig?.environmentDetails?.costCenter,
                            'Project Name': item?.catalogConfig?.environmentDetails?.projectName,
                        })),
                ...(!storageBlog.includes(item?.catalogServiceCode) &&
                    !keyvaultCatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    !AlbCatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    !kafkaCatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    !AwsKafkaTopicCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !eventhubDefinitionId.includes(item?.catalogServiceCode) &&
                    !pECatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    !NsgAutomationRulesProvisioningCatalogDefinitionID.includes(item?.catalogServiceCode) &&
                    !adfCatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    !eipStackCatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    !ApplicationGateWayURLCatalogDefinitionID?.includes(item.catalogServiceCode) &&
                    !InternalApplicationGateWayURLCatalogDefinitionID?.includes(item.catalogServiceCode) &&
                    !ExternalPublicLoadBalancerURLCatalogDefinitionID?.includes(item.catalogServiceCode) &&
                    !NewInternalApplicationGateWayProvisioningCatalogDefinitionID?.includes(item.catalogServiceCode) &&
                    !CloudOnboardingCatalogDefinitionID?.includes(item.catalogServiceCode) &&
                    !edapAksCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsEC2CatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsRHELCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsRHELCBCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsSLESCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsOELCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !edapAksCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !EDAPAzureNodePoolCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsEksnCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsOracleRDSCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsS3BucketCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsSQLRDSCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsMYSQLRDSCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsPostgresqlCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsDynamoDbCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsSQLIaasCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsOracle19CCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsNLBCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsExternalNLBCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsALBCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !MySQLFlexibleDbCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !PostgreSQLFlexibleDbCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsCloudOnboardingCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsAccountVendingCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !CosmosDbCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsLambdaFunctionCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsInternalUrlOnboardingCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsLexCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsExternalURLOnboardingCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsSNSCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !PCWindowsCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !PCLinuxCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsSQSCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AzureOracleExadataCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsDocumentDBCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !PCSQLIaasCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !PgtSapSolutionCatalogDefinitionId?.includes(item.catalogServiceCode) && {
                        'Cost Center': item?.catalogConfig?.environmentDetails?.costCenter,
                        'Project Name': item?.catalogConfig?.environmentDetails?.projectName,
                        'Billing Entity': item?.catalogConfig?.billingEntity,
                    }),
                ...(keyvaultCatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    eventhubDefinitionId.includes(item?.catalogServiceCode) && {
                        'Cost Center': item?.catalogConfig?.environmentDetails?.costCenter,
                        'Project Name': item?.catalogConfig?.environmentDetails?.projectName,
                    }),
                // 'Cost Center': item.catalogConfig.environmentDetails.costCenter,
                ...(storageBlog.includes(item?.catalogServiceCode) && {
                    'Access Tier': item?.catalogConfig?.accessTier,
                    'Storage Account Name': item?.catalogConfig?.accountName,
                    'Container Name': item?.catalogConfig?.containerName,
                    Capacity: item?.catalogConfig?.capacity,
                    Redundancy: item?.catalogConfig?.redundancy,
                    Performance: item?.catalogConfig?.performance,
                    'ADLS Gen2 Enabled': item?.catalogConfig?.isAdls ? 'Yes' : 'No',
                    'Versioning Enabled': item?.catalogConfig?.versionEnabled ? 'Yes' : 'No',
                    // 'Large File Share Enabled': item?.catalogConfig?.fileShareEnabled ? 'Yes' : 'No',
                }),
                ...(aksNS.includes(item.catalogServiceCode) && {
                    Department: item?.catalogConfig?.environmentDetails?.department,
                    Cluster: item?.catalogConfig?.cluster,
                    'Catalog Size': item?.catalogConfig?.size,
                    'Business Unit': item?.catalogConfig?.environmentDetails?.businessUnit,
                    'ISA Document': item?.catalogConfig?.environmentDetails?.isaDocument,
                    Project: item?.catalogConfig?.project,
                    'AD Group': item?.catalogConfig?.adGroup,
                    'Application Support DL': item?.catalogConfig?.appSupportMailId,
                    // Keyvault Configuration
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.resourceGroup, 'Resource Group'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.virtualNetwork, 'Virtual Network'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.subNetName, 'Subnet'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.keyVaultRequired, 'Key Vault Required'),
                    ...addPropertyIfExists(item?.catalogConfig?.keyVaultName, 'Key Vault Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.managedIdentityName, 'User Assigned Identity Name'),
                    // Non-Privileged AD Group
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.readerObjectNames) ? item?.catalogConfig?.readerObjectNames.join(', ') : null,
                        'Active Directory Group Reader'
                    ),
                    // Privileged AD Group
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.adminObjectNames) ? item?.catalogConfig?.adminObjectNames.join(', ') : null,
                        'Active Directory Group Contributor'
                    ),
                }),
                ...([...AwsEksnCatalogDefinitionId, ...edapAksCatalogDefinitionId, ...EDAPAzureNodePoolCatalogDefinitionId].includes(
                    item.catalogServiceCode
                ) && {
                    ...(item?.catalogConfig?.environmentDetails?.costCenter && { 'Cost Center': item?.catalogConfig?.environmentDetails?.costCenter }),
                    ...(item?.catalogConfig?.environmentDetails?.projectName && { 'Project Name': item?.catalogConfig?.environmentDetails?.projectName }),
                    ...(item?.catalogConfig?.applicationService && { applicationService: item?.catalogConfig?.applicationService }),
                    ...(item?.catalogConfig?.requestType && { requestType: item?.catalogConfig?.requestType }),
                    ...(item?.catalogConfig?.environmentDetails?.department && { Department: item?.catalogConfig?.environmentDetails?.department }),
                    ...(item.catalogConfig?.environmentDetails?.clusterName && { Cluster: item.catalogConfig?.environmentDetails?.clusterName }),
                    ...(item?.catalogConfig?.department && { Department: item?.catalogConfig?.department }),
                    ...(item?.catalogConfig?.program && { Program: item?.catalogConfig?.program }),
                    ...(item.catalogConfig?.eksClusterName && { Cluster: item.catalogConfig?.eksClusterName }),
                    ...(item?.catalogConfig?.project && { Project: item?.catalogConfig?.project }),
                    ...(item?.catalogConfig?.adGroup && { 'AD Group': item?.catalogConfig?.adGroup }),
                    ...(item?.catalogConfig?.appSupportMailId && { 'Application Support DL': item?.catalogConfig?.appSupportMailId }),
                    ...(item?.catalogConfig?.applicationUrl && { 'Application URL': item?.catalogConfig?.applicationUrl }),
                    ...(item?.catalogConfig?.namespace && { namespaceName: item?.catalogConfig?.namespace }),
                    ...(item?.catalogConfig?.eksNamespace && { 'EKS Namespace': item?.catalogConfig?.eksNamespace }),
                    ...(item?.catalogConfig?.nodePool && { nodePool: item?.catalogConfig?.nodePool }),
                    ...(item?.catalogConfig?.supportBackendCertificate && { 'Support Backend Certificate': item?.catalogConfig?.supportBackendCertificate }),
                    ...(item?.catalogConfig?.applicationName && { 'Application Name': item?.catalogConfig?.applicationName }),
                    ...(item?.catalogConfig?.applicationShortName && { 'Application Short Name': item?.catalogConfig?.applicationShortName }),
                    ...(item?.catalogConfig?.applicationRegion && { 'Application Region': item?.catalogConfig?.applicationRegion }),
                    ...(item?.catalogConfig?.size && { size: item?.catalogConfig?.size }),
                }),
                ...(EDAPAzureNodePoolCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.businessService, 'Application Service'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationDetails?.supportContact, 'Support Contact'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationDetails?.businessContact, 'Business Contact'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationDetails?.orgGroupCode, 'Org Group Code'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationDetails?.projectNumber, 'Project Number'),
                    ...addPropertyIfExists(item?.catalogConfig?.projectName, 'Project Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationDetails?.isaNumber, 'ISA Number'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationDetails?.dataClassification, 'Data Classification'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationDetails?.cloudOnboardingRequest, 'Cloud Onboarding Request'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationDetails?.edapPlatformOwner, 'EDAP Platform Owner'),
                    ...addPropertyIfExists(item?.catalogConfig?.nodePoolName, 'Node Pool Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.vmConfiguration?.osType, 'OS Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.vmConfiguration?.osSku, 'OS SKU'),
                    ...addPropertyIfExists(item?.catalogConfig?.vmConfiguration?.vmType, 'VM Type'),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.vmConfiguration?.availabilityZones)
                            ? item?.catalogConfig?.vmConfiguration?.availabilityZones.join(', ')
                            : item?.catalogConfig?.vmConfiguration?.availabilityZones,
                        'Availability Zones'
                    ),
                    ...addPropertyIfExists(item?.catalogConfig?.vmConfiguration?.osDiskType, 'OS Disk Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.vmConfiguration?.osDiskTypeSize, 'OS Disk Size (GB)'),
                    ...(item?.catalogConfig?.nodeConfiguration?.nodeCount !== null &&
                        item?.catalogConfig?.nodeConfiguration?.nodeCount !== undefined && {
                            'Node Count': item?.catalogConfig?.nodeConfiguration?.nodeCount,
                        }),
                    ...(item?.catalogConfig?.nodeConfiguration?.minNode !== null &&
                        item?.catalogConfig?.nodeConfiguration?.minNode !== undefined && {
                            'Min Node': item?.catalogConfig?.nodeConfiguration?.minNode,
                        }),
                    ...(item?.catalogConfig?.nodeConfiguration?.maxNode !== null &&
                        item?.catalogConfig?.nodeConfiguration?.maxNode !== undefined && {
                            'Max Node': item?.catalogConfig?.nodeConfiguration?.maxNode,
                        }),
                    ...(item?.catalogConfig?.nodeConfiguration?.maxPods !== null &&
                        item?.catalogConfig?.nodeConfiguration?.maxPods !== undefined && {
                            'Max Pods': item?.catalogConfig?.nodeConfiguration?.maxPods,
                        }),
                    ...addPropertyIfExists(item?.catalogConfig?.taints, 'Taints'),
                }),
                ...(AwsSQSCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    ...addPropertyIfExists(item?.catalogConfig?.applicationService, 'Application Service'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationName, 'Application Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.appShortName, 'Application Short Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.applicationTier, 'App Tier'),
                    ...addPropertyIfExists(item?.sector, 'Sector'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.department, 'Department'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.applicationRegion, 'Application Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.environment, 'Environment'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.region, 'AWS Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.costCenter, 'Cost Center'),
                    ...addPropertyIfExists(orders?.entityDetails?.applicationManager, 'Application Owner'),
                    ...addPropertyIfExists(item?.catalogConfig?.accountName, 'AWS Account Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.accountId, 'AWS Account ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.awsQueueType, 'SQS Queue Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.awsQueueName, 'Queue Name'),
                }),
                ...(AlbCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    instanceName: item?.catalogConfig?.instanceName,
                    FQDNS: item?.catalogConfig?.fqdns,
                    frontendPoolName: item?.catalogConfig?.frontEndPoolName,
                    backendPoolName: item?.catalogConfig?.backEndPools[0]?.poolName,
                    poolConfigurations: item?.catalogConfig?.backEndPools[0]?.poolConfig,
                    virtualMachines: item?.catalogConfig?.backEndPools[0]?.virtualMachines
                        ?.map((vm) => `${vm?.virtualMachineName} (IP: ${vm?.ipAddress})`)
                        ?.join(', '),
                    vNet: item?.catalogConfig?.environmentDetails?.virtualNetwork,
                    rulesName: item?.catalogConfig?.loadBalancerRules[0]?.rulesName,
                    protocol: item?.catalogConfig?.loadBalancerRules[0]?.protocol,
                    frontendPort: item?.catalogConfig?.loadBalancerRules[0]?.frontEndPort,
                    backendPort: item?.catalogConfig?.loadBalancerRules[0]?.backEndPort,
                    sessionPersistance: item?.catalogConfig?.loadBalancerRules[0]?.sessionPersistance,
                    ...(item?.catalogConfig?.loadBalancerRules[0]?.protocols?.toLowerCase() === 'tcp' && {
                        timeOut: item?.catalogConfig?.loadBalancerRules[0]?.idealTimeout,
                    }),
                    healthProbeName: item?.catalogConfig?.loadBalancerRules[0]?.healthProbe?.healthProbeName,
                    healthProbeProtocol: item?.catalogConfig?.loadBalancerRules[0]?.healthProbe?.protocols,
                    healthProbePort: item?.catalogConfig?.loadBalancerRules[0]?.healthProbe?.port,
                    ...(['http', 'https'].includes(item?.catalogConfig?.loadBalancerRules[0]?.healthProbe?.protocols?.toLowerCase()) && {
                        healthProbePathUrl: item?.catalogConfig?.loadBalancerRules[0]?.healthProbe?.pathUrl,
                    }),
                }),
                ...(AwsExternalURLOnboardingCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    ...addPropertyIfExists(item?.catalogConfig?.dataClassification, 'Data Classification'),
                    ...addPropertyIfExists(item?.catalogConfig?.onboardingType, 'OnBoarding Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.trafficType, 'Traffic Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.isaNumber, 'ISA Number'),
                    ...addPropertyIfExists(item?.catalogConfig?.infosecEnvironment, 'Infosec Environment'),
                    ...addPropertyIfExists(item?.catalogConfig?.infosecAppUrl, 'Infosec App URL'),
                    ...addPropertyIfExists(item?.catalogConfig?.eksClusterName, 'AWS EKS Cluster Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.sharedNetworkAccount, 'AWS Shared Account Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.sharedNetworkAccountId, 'Shared Network Account ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalAlbName, 'External ALB Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalAlbArn, 'External ALB ARN Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalNlbName, 'External NLB Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalNlbArn, 'External NLB ARN Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.dnsName, 'External NLB DNS Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalAlbRuleName, 'ALB Rule Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalAlbTargetGroup?.name, 'ALB Target Group Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalAlbTargetGroup?.targetType, 'Target Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalAlbTargetGroup?.protocol, 'Target Protocol'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalAlbTargetGroup?.port, 'Target Port'),
                    ...addPropertyIfExists(item?.catalogConfig?.nlbTargetInstanceIps?.join(', '), "NLB Target Instance IP's"),
                }),
                ...(AwsExternalNLBCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    ...addPropertyIfExists(item.catalogConfig?.applicationService, 'Application Service'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationName, 'Application Name'),
                    ...addPropertyIfExists(item?.sector, 'Sector'),
                    ...addPropertyIfExists(item?.catalogConfig?.department, 'Department'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationRegion, 'Application Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.environment, 'Environment'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.region, 'Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.costCenter, 'Cost Center'),
                    ...addPropertyIfExists(item?.catalogConfig?.dataClassification, 'Data Classification'),
                    ...addPropertyIfExists(item?.catalogConfig?.appSupportMailId, 'Application Support Mail ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.awsSharedAccount, 'AWS Shared Account Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.awsSharedAccountId, 'AWS Shared Account ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalNlbName, 'External NLB Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.listeners?.protocol, 'NLB Listener Protocol'),
                    ...addPropertyIfExists(item?.catalogConfig?.listeners?.port, 'NLB Listener Port'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.accountName, 'AWS Account Name'),
                    // ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.awsAccountId, 'AWS Account ID'),
                    ...addPropertyIfExists(item?.catalogConfig?.internalNlbRuleName, 'Internal NLB Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalNlbRuleName, 'External NLB Rule Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.applicationShortName, 'App Short Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.vpcName, 'VPC Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.vpcId, 'VPC ID'),
                    // ...addPropertyIfExists(item?.catalogConfig?.trafficType, 'Traffic Type'),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.subnetName) ? item?.catalogConfig?.subnetName.join(', ') : item?.catalogConfig?.subnetName,
                        'Subnet Names'
                    ),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.subnetId) ? item?.catalogConfig?.subnetId.join(', ') : item?.catalogConfig?.subnetId,
                        'Subnet IDs'
                    ),
                    ...addPropertyIfExists(item?.catalogConfig?.externalNlbTargetGroup?.name, 'NLB Target Group Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalNlbTargetGroup?.targetType, 'Target Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalNlbTargetGroup?.protocol, 'Target Protocol'),
                    ...addPropertyIfExists(item?.catalogConfig?.externalNlbTargetGroup?.port, 'Target Port'),
                    ...addPropertyIfExists(
                        Array.isArray(item?.catalogConfig?.externalNlbTargetGroup?.ips)
                            ? item?.catalogConfig?.externalNlbTargetGroup?.ips.join(', ')
                            : item?.catalogConfig?.externalNlbTargetGroup?.ips,
                        'Target IPs'
                    ),
                    ...addPropertyIfExists(item?.catalogConfig?.healthCheck?.protocol, 'Health Check Protocol'),
                    ...addPropertyIfExists(item?.catalogConfig?.healthCheck?.path, 'Health Check Path'),
                    ...addPropertyIfExists(item?.catalogConfig?.healthCheck?.port, 'Health Check Port'),
                }),
                ...(eventhubDefinitionId.includes(item.catalogServiceCode) && {
                    'Namespace Exist': item?.catalogConfig?.namespaceExist,
                    'Namespace Name': item?.catalogConfig?.namespaceName,
                    Performance: item?.catalogConfig?.performance,
                    ...(item?.catalogConfig?.performance === 'Standard' && {
                        'Throughput Unit': item?.catalogConfig?.throughputUnit,
                        'Enable AutoInflate': item?.catalogConfig?.enableAutoInflate,
                    }),
                    ...(item?.catalogConfig?.performance === 'Standard' &&
                        item?.catalogConfig?.enableAutoInflate === 'yes' && {
                            'AutoInflate Maximum ThroughputUnit': item?.catalogConfig?.autoInflateMaximumThroughputUnit,
                        }),
                    ...(item?.catalogConfig?.performance === 'Premium' && {
                        'Processing Unit': item?.catalogConfig?.processingUnit,
                    }),
                    ...(item?.catalogConfig?.environmentDetails?.environment === 'Production' && {
                        'Enable GeoReplication': item?.catalogConfig?.enableGeoReplication,
                    }),
                    ...(item?.catalogConfig?.environmentDetails?.environment === 'Production' &&
                        item?.catalogConfig?.enableGeoReplication === 'yes' && {
                            'Geo-replication Region': item?.catalogConfig?.geoRecoveryRegion,
                        }),
                    'TLS Version': item?.catalogConfig?.tlsVersion,
                    Project: item?.catalogConfig?.environmentDetails?.projectName,
                }),

                ...(!sqlPaaS.includes(item.catalogServiceCode) &&
                    !storageBlog.includes(item.catalogServiceCode) &&
                    !aksNS.includes(item.catalogServiceCode) &&
                    !AlbCatalogDefinitionId.includes(item.catalogServiceCode) &&
                    !keyvaultCatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    !kafkaCatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    !AwsKafkaTopicCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !eventhubDefinitionId.includes(item?.catalogServiceCode) &&
                    !pECatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    !NsgAutomationRulesProvisioningCatalogDefinitionID.includes(item?.catalogServiceCode) &&
                    !adfCatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    !eipStackCatalogDefinitionId.includes(item?.catalogServiceCode) &&
                    !couchbaseDbDefinitionId.includes(item?.catalogServiceCode) &&
                    !ApplicationGateWayURLCatalogDefinitionID?.includes(item?.catalogServiceCode) &&
                    !InternalApplicationGateWayURLCatalogDefinitionID?.includes(item?.catalogServiceCode) &&
                    !NewInternalApplicationGateWayProvisioningCatalogDefinitionID?.includes(item?.catalogServiceCode) &&
                    !CloudOnboardingCatalogDefinitionID?.includes(item?.catalogServiceCode) &&
                    !ExternalPublicLoadBalancerURLCatalogDefinitionID?.includes(item?.catalogServiceCode) &&
                    !AwsEC2CatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsRHELCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsRHELCBCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsSLESCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsOELCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsDynamoDbCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsSQLIaasCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsOracle19CCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsNLBCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsALBCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsExternalNLBCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !ExternalPublicLoadBalancerURLCatalogDefinitionID?.includes(item?.catalogServiceCode) &&
                    !MySQLFlexibleDbCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !PostgreSQLFlexibleDbCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsCloudOnboardingCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsAccountVendingCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsEksnCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !CosmosDbCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !EDAPAzureNodePoolCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsLambdaFunctionCatalogDefinitionId?.includes(item.catalogServiceCode) &&
                    !AwsInternalUrlOnboardingCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsLexCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsExternalURLOnboardingCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsSNSCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !PCLinuxCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !PCWindowsCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsSQSCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AzureOracleExadataCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !AwsDocumentDBCatalogDefinitionId?.includes(item?.catalogServiceCode) &&
                    !PCSQLIaasCatalogDefinitionId?.includes(item?.catalogServiceCode) && {
                        'Server Refresh Enabled': `${item?.catalogConfig?.serverRefresh === true ? 'Yes' : 'No'}`,
                        ...(item?.catalogConfig?.serverRefresh === true && {
                            'Retiring ServerName': item?.catalogConfig?.retiringServerName,
                            'Scheduled Retirement Date': item?.catalogConfig?.scheduledRetirement,
                            'Disposal Reason': item?.catalogConfig?.disposalReason,
                        }),
                    }),
                ...([
                    ...windowsCatalogDefinitionId,
                    ...linuxCatalogDefinitionId,
                    ...sqlIaaSCatalogDefinitionId,
                    ...oracleIaaSDefinitionId,
                    ...pgcsSqlIaaSCatalogDefinitionId,
                    ...pgcsWindowsVmCatalogDefinitionId,
                ].includes(item.catalogServiceCode) && {
                    'Accelerated Networking Enabled': `${item?.catalogConfig?.acceleratedNetworking === true ? 'Yes' : 'No'}`,
                }),
                ...([...sqlIaaSCatalogDefinitionId].includes(item.catalogServiceCode) &&
                    item?.catalogConfig?.isSqlIaaSOn && {
                        'SQL IaaS ON': item?.catalogConfig?.isSqlIaaSOn,
                    }),
                ...(item?.catalogConfig?.secondaryResourceGroup && {
                    'Resource Group': item?.catalogConfig?.secondaryResourceGroup,
                }),
                ...(item?.catalogConfig?.secondaryVirtualNetwork && {
                    'Virtual Network for Disaster Recovery': item?.catalogConfig?.secondaryVirtualNetwork,
                }),
                ...(item?.catalogConfig?.secondarySubnet && {
                    'Subnet for Disaster Recovery': item?.catalogConfig?.secondarySubnet,
                }),
                ...(oracleIaaS.includes(item.catalogServiceCode) && {
                    ...(item?.catalogConfig?.oracleId && {
                        oracleId: item?.catalogConfig?.oracleId,
                    }),
                    'Oracle Version': item?.catalogConfig?.oracleVersion,
                    'Database National Character Set': item?.catalogConfig?.dbNationalCharSet,
                    'Database Character Set': item?.catalogConfig?.dbCharacterSet,
                    'Database Name': item?.catalogConfig?.dbName,
                    'DB Size': `${item?.catalogConfig?.dbSize} GB`,
                }),
                ...(oelOracleCatalogDefinitionId?.includes(item?.catalogServiceCode) && {
                    'Are you migrating database older than 19c?': item?.catalogConfig?.migratePre19cDB === true ? 'Yes' : 'No',
                    'NVMe Support': item?.catalogConfig?.nvmeSupport === true ? 'Yes' : 'No',
                    ...(item?.catalogConfig?.nvmeSupport === true && {
                        catalogSize: item?.catalogConfig?.catalogSize,
                    }),
                    'OS SKU Image Name': item?.catalogConfig?.os?.osSkuImageName,
                    ...(item?.catalogConfig?.environmentDetails?.environment === 'Production' && {
                        'Azure Site Recovery': item.catalogConfig.azureSiteRecovery ? 'Yes' : 'No',
                    }),
                }),
                ...((sqlIaaS.includes(item.catalogServiceCode) || pgcsSqlIaaSCatalogDefinitionId.includes(item?.catalogServiceCode)) && {
                    'Sql Version': item?.catalogConfig?.sqlVersion,
                    'Database Name': item?.catalogConfig?.dbName,
                    'DB Size': `${item?.catalogConfig?.dbSize} GB`,
                    'Server Collation': item.catalogConfig.sqlServerCollation,
                    'Services Installed': item.catalogConfig.services?.length > 1 ? item.catalogConfig.services.join(', ') : item.catalogConfig.services,
                    'Server Refresh': `${item?.catalogConfig?.serverRefresh === true ? 'Yes' : 'No'}`,
                    ...addPropertyIfExists(item?.catalogConfig?.applicationName, 'Application Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.appShortName, 'App Short Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.gmsaServiceAccount, 'GMSA Service Account'),
                    ...addPropertyIfExists(item?.catalogConfig?.gmsaComputerGroup, 'GMSA Computer Group'),
                }),
                ...(keyvaultCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    'Key Vault Name': item?.catalogConfig?.keyVaultName,
                    'Pricing Tier': item?.catalogConfig?.pricingTier,
                    'Vault Access Policy': item?.catalogConfig?.vaultAccessPolicy,
                }),
                ...(pECatalogDefinitionId.includes(item.catalogServiceCode) && {
                    Subscription: item?.catalogConfig?.subscription,
                    'Resource Type': item?.catalogConfig?.resourceType,
                    Resource: item?.catalogConfig?.resource,
                    Target_Sub_Resource: item?.catalogConfig?.targetSubResource,
                    'Private EndPointType': item?.catalogConfig?.privateEndpointType,
                    ...(item?.catalogConfig?.privateEndpointType === 'Isolated' && {
                        'Databricks Subscription': item?.catalogConfig?.databricksSubscription,
                        'Databrick/AML Workspace': item?.catalogConfig?.databricks,
                    }),
                }),
                ...(eipStackCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    'Domain Name Service': `${item?.catalogConfig?.isDnsRequired === true ? 'Yes' : 'No'}`,
                    ...(item?.catalogConfig?.isDnsRequired && {
                        'FQDN Name': item?.catalogConfig?.fqdn,
                        'IP Address': item?.catalogConfig?.ipAddress,
                        'SSL Certificate': item?.catalogConfig?.sslCertificate,
                    }),
                    'ECE Integration': `${item?.catalogConfig?.isEceRequired === true ? 'Yes' : 'No'}`,
                    ...(item?.catalogConfig?.isEceRequired && {
                        'IT LDAP Group': item?.catalogConfig?.ldapGroup,
                    }),
                    'CLE Integration': `${item?.catalogConfig?.isEceRequired === true ? 'Yes' : 'No'}`,
                    ...(item?.catalogConfig?.isCleRequired && {
                        'Catalog Size ': item?.catalogConfig?.ldapGroup,
                        'ServiceNow Assignment Group': item?.catalogConfig?.serviceNowAssignmentGroup,
                    }),
                    'Conjure Integration': `${item?.catalogConfig?.isConjourRequired === true ? 'Yes' : 'No'}`,
                    ...(item?.catalogConfig?.isConjourRequired && {
                        'Safe Name': item?.catalogConfig?.safeName,
                        SOX: item?.catalogConfig?.sox,
                    }),
                }),

                ...(adfCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    'Cost Center': item?.catalogConfig?.environmentDetails?.costCenter,
                    'Project Name': item?.catalogConfig?.environmentDetails?.projectName,
                    'Billing Entity': item?.catalogConfig?.billingEntity,
                    subscription: item?.catalogConfig?.environmentDetails?.subscription,
                    resourceGroup: item?.catalogConfig?.environmentDetails?.resourceGroup,
                    Data_Factory_Name: item?.catalogConfig?.resource?.name,
                    Version: item?.catalogConfig?.resource?.version,
                }),
                ...(ApplicationGateWayURLCatalogDefinitionID?.includes(item.catalogServiceCode) && {
                    'Application Name': item?.catalogConfig?.applicationName,
                    'Application Owner ID': item?.catalogConfig?.applicationOwnerId,
                    Environment: item?.catalogConfig?.environment,
                    sector: item?.catalogConfig.sector,
                    'Application Service': item.catalogConfig?.applicationService,
                    // Region: item?.catalogConfig?.region,
                    'Budget Code': item?.catalogConfig?.budgetCode,
                    'Application URL': item?.catalogConfig?.applicationUrl,
                    'SSL Encryption': item?.catalogConfig?.sslEncryption === true ? 'Yes' : 'No',
                    ...(item?.catalogConfig?.sslEncryption === true && {
                        SupportBackendCertificate: item?.catalogConfig?.supportBackendCertificate,
                    }),
                    ...(item?.catalogConfig?.routeType && {
                        RouteType: item?.catalogConfig?.routeType,
                    }),
                    ...(item?.catalogConfig?.routingPath && {
                        RoutingPath: item?.catalogConfig?.routingPath,
                    }),
                    Program: item?.catalogConfig?.program || '-',
                    BackEndHealthProbePath: item?.catalogConfig?.backendHealthProbePath,
                    'Backend FQDN': item?.catalogConfig?.backendFqdn,
                    ...(item?.catalogConfig?.isaNumber && {
                        'ISA Number': item?.catalogConfig?.isaNumber,
                    }),
                    ...(item?.catalogConfig?.scanNumber && {
                        'SCAN Number': item?.catalogConfig?.scanNumber,
                    }),
                    // ...(item?.catalogConfig?.adGroup && {
                    //     'AD Group': item?.catalogConfig?.adGroup,
                    // }),
                    ...(item?.catalogConfig?.activeDirectoryCertificateGroup && {
                        'Active Directory Certificate Group': item?.catalogConfig?.activeDirectoryCertificateGroup,
                    }),
                    ...(item?.catalogConfig?.appSupportMailId && {
                        'Application Support Mail ID': item?.catalogConfig?.appSupportMailId,
                    }),
                    ...(item?.catalogConfig?.filesUploadResponse && {
                        uploadScan: item?.catalogConfig?.filesUploadResponse?.uploadResponses,
                    }),
                    // ...(item?.catalogConfig?.certificateOwnerOne && {
                    //     'Certificate Owner 1 ID': item?.catalogConfig?.certificateOwnerOne,
                    // }),
                    // ...(item?.catalogConfig?.certificateOwnerTwo && {
                    //     'Certificate Owner 2 ID': item?.catalogConfig?.certificateOwnerTwo,
                    // }),
                    'GTM LoadBalancer IP Address': item?.catalogConfig?.gtmLoadBalancerIpAddress,
                }),
                ...(AwsLambdaFunctionCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    ...addPropertyIfExists(item?.catalogConfig?.lambdaFunctionName, 'Function Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.memorySize, 'Memory'),
                    ...addPropertyIfExists(item?.catalogConfig?.timeout, 'Timeout'),
                    ...addPropertyIfExists(item?.catalogConfig?.architecture, 'Architecture'),
                    ...addPropertyIfExists(item?.catalogConfig?.codeDeploymentMethod, 'Code Deployment Method'),
                    ...addPropertyIfExists(item?.catalogConfig?.adoProject, 'ADO Project'),
                    ...addPropertyIfExists(item?.catalogConfig?.repository, 'Repository'),
                    ...addPropertyIfExists(item?.catalogConfig?.branch, 'Branch'),
                    ...addPropertyIfExists(item?.catalogConfig?.runtime, 'Runtime'),
                    ...addPropertyIfExists(item?.catalogConfig?.handler, 'Handler'),
                    ...addBooleanPropertyIfExists(item?.catalogConfig?.enableVpc, 'Enable VPC'),
                    ...addPropertyIfExists(item?.catalogConfig?.connectivityType, 'Connectivity Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.containerImageUrl, 'Container Image URL'),
                }),
                ...(AwsSNSCatalogDefinitionId.includes(item.catalogServiceCode) && {
                    ...addPropertyIfExists(item?.catalogConfig?.topicName, 'Topic Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.displayName, 'Display Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.topicType, 'Topic Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.messageRetentionPeriod, 'Message Retention Period'),
                    ...addPropertyIfExists(item?.catalogConfig?.contentBasedDeduplication, 'Content-Based Deduplication'),
                    ...addPropertyIfExists(item?.catalogConfig?.deliveryRetryPolicy, 'Delivery Retry Policy'),
                    ...Object.entries(item?.catalogConfig || {})
                        ?.filter(([, v]) => v && typeof v === 'object' && v?.endpoint)
                        ?.reduce((acc, [key, val]) => {
                            const label = key?.charAt(0).toUpperCase() + key?.slice(1);
                            return {
                                ...acc,
                                ...addPropertyIfExists(val?.protocol, `${label} Protocol`),
                                ...addPropertyIfExists(val?.endpoint, `${label} Endpoint`),
                            };
                        }, {}),
                }),
                ...([
                    ...PCWindowsCatalogDefinitionId,
                    ...PCLinuxCatalogDefinitionId,
                    ...PCSQLIaasCatalogDefinitionId,
                    ...PCOracleDBCatalogDefinitionId,
                ]?.includes(item.catalogServiceCode) && {
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.businessService, 'Application Service'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.applicationTier, 'App Tier'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.environment, 'Environment'),
                    ...addPropertyIfExists(item?.sector, 'Sector'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.dtc, 'Location'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.costCenter, 'Cost Center'),
                    ...addPropertyIfExists(item?.catalogConfig?.tags?.['pep-business-category'], 'Business Category'),
                    ...addPropertyIfExists(item?.catalogConfig?.tags?.['pep-dataclassification'], 'Data Classification'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.applicationManager, 'App Owner'),
                    ...addPropertyIfExists(item?.catalogConfig?.billingEntity, 'Billing Entity'),
                    ...addPropertyIfExists(item?.catalogConfig?.clusterType, 'Cluster Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.clusterName, 'Cluster Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.vlanType, 'VLAN Type'),
                    ...addPropertyIfExists(item?.catalogConfig?.vlanName, 'VLAN Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.os?.osName, 'OS Template'),
                    ...addPropertyIfExists(item?.catalogConfig?.cpu, 'CPU (vCPUs)'),
                    ...addPropertyIfExists(item?.catalogConfig?.memoryGiB, 'Memory (GB)'),
                    ...addPropertyIfExists(item?.timeZone, 'Time Zone'),
                    ...addPropertyIfExists(item?.quantity, 'Quantity'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.domain, 'Domain'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.adOu, 'AD OU'),
                    ...addPropertyIfExists(item?.catalogConfig?.samAccountId, 'SAM Account'),
                    ...addPropertyIfExists(item?.catalogConfig?.adGroup, 'AD Group'),
                }),
                ...([...PCSQLIaasCatalogDefinitionId]?.includes(item.catalogServiceCode) && {
                    ...addPropertyIfExists(item?.catalogConfig?.appShortName, 'App Short Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.gmsaServiceAccount, 'GMSA Service Account'),
                    ...addPropertyIfExists(item?.catalogConfig?.gmsaComputerGroup, 'GMSA Computer Group'),
                    ...addPropertyIfExists(item?.catalogConfig?.sqlVersion, 'SQL Version'),
                    ...(item?.catalogConfig?.services?.length && { 'Services Installed': item?.catalogConfig?.services?.join(', ') }),
                    ...addPropertyIfExists(item?.catalogConfig?.sqlServerCollation, 'SQL Server Collation'),
                    ...addPropertyIfExists(item?.catalogConfig?.dbName, 'Database Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.dbSize, 'Expected DB Size(GB)'),
                }),
                ...([...PCOracleDBCatalogDefinitionId]?.includes(item.catalogServiceCode) && {
                    ...addPropertyIfExists(item?.catalogConfig?.oracleVersion, 'Oracle Version'),
                    ...(item?.catalogConfig?.nvmeSupport !== undefined &&
                        item?.catalogConfig?.nvmeSupport !== null && {
                            'NVMe Support': item?.catalogConfig?.nvmeSupport === true ? 'Yes' : 'No',
                        }),
                    ...addPropertyIfExists(item?.catalogConfig?.dbNationalCharSet, 'DB National Character Set'),
                    ...addPropertyIfExists(item?.catalogConfig?.dbCharacterSet, 'DB Character Set'),
                    ...addPropertyIfExists(item?.catalogConfig?.dbName, 'Database Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.dbSize && `${item?.catalogConfig?.dbSize} GB`, 'Expected DB Size(GB)'),
                }),
                ...(AzureOracleExadataCatalogDefinitionId?.includes(item.catalogServiceCode) && {
                    ...addPropertyIfExists(item?.catalogConfig?.applicationService, 'Application Service'),
                    ...addPropertyIfExists(item?.sector, 'Sector'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.environment, 'Environment'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.region, 'Region'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.costCenter, 'Cost Center'),
                    ...addPropertyIfExists(item?.catalogConfig?.environmentDetails?.applicationTier, 'App Tier'),
                    ...addPropertyIfExists(item?.catalogConfig?.exadataInfrastructureName, 'Exadata Infrastructure'),
                    ...addPropertyIfExists(item?.catalogConfig?.cloudVmClusterName, 'VM Cluster'),
                    ...addPropertyIfExists(item?.catalogConfig?.resourceGroupName, 'Resource Group'),
                    ...addPropertyIfExists(item?.catalogConfig?.oracleDatabaseName, 'Database Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.databaseUniqueName, 'Database Unique Name'),
                    ...addPropertyIfExists(item?.catalogConfig?.databaseArchitecture, 'Database Architecture'),
                    ...addPropertyIfExists(item?.catalogConfig?.oracleDatabaseVersion, 'Oracle Database Version'),
                    ...addPropertyIfExists(item?.catalogConfig?.ocpuCount, 'CPU Count'),
                    ...addPropertyIfExists(item?.catalogConfig?.sgaSizeInGb, 'SGA Size (GB)'),
                    ...addPropertyIfExists(item?.catalogConfig?.pgaSizeInGb, 'PGA Size (GB)'),
                    ...addPropertyIfExists(item?.catalogConfig?.databaseCharacterSet, 'Database Character Set'),
                    ...addPropertyIfExists(item?.catalogConfig?.nationalCharacterSet, 'National Character Set'),
                }),
                ...(InternalApplicationGateWayURLCatalogDefinitionID?.includes(item.catalogServiceCode) && getInternalAppGatewaySummary(item)),
                ...(ExternalPublicLoadBalancerURLCatalogDefinitionID?.includes(item.catalogServiceCode) && getExternalPublicLoadBalancerSummary(item)),
                ...(NewInternalApplicationGateWayProvisioningCatalogDefinitionID?.includes(item.catalogServiceCode) && getNewInternalAppGatewaySummary(item)),
                ...([...CloudOnboardingCatalogDefinitionID, ...AwsCloudOnboardingCatalogDefinitionId, ...AwsAccountVendingCatalogDefinitionId]?.includes(
                    item.catalogServiceCode
                ) && getCloudOnboardingSummary(item, orders)),
                ...(item?.estimatedCost &&
                    ![
                        ...ApplicationGateWayURLCatalogDefinitionID,
                        ...InternalApplicationGateWayURLCatalogDefinitionID,
                        ...ExternalPublicLoadBalancerURLCatalogDefinitionID,
                        ...NewInternalApplicationGateWayProvisioningCatalogDefinitionID,
                        ...CloudOnboardingCatalogDefinitionID,
                        ...AwsCloudOnboardingCatalogDefinitionId,
                        ...AwsAccountVendingCatalogDefinitionId,
                    ]?.includes(item.catalogServiceCode) && {
                        cost: item?.estimatedCost,
                    }),
            };
            if (item?.catalogConfig?.os) {
                orderItemDetails.osType = item?.catalogConfig?.os?.osType;
                if (item?.catalogConfig?.diskDefinitions?.length > 0) {
                    orderItemDetails.dataDisks = [...orderItemDetails.dataDisks, ...item?.catalogConfig?.diskDefinitions];
                }
            }
            if (item?.catalogConfig?.eventHubDetails && item?.catalogConfig?.eventHubDetails?.length > 0) {
                orderItemDetails.eventHubDetails = [...orderItemDetails.eventHubDetails, ...item?.catalogConfig?.eventHubDetails];
            }
            if (
                item?.catalogConfig?.environmentDetails &&
                item?.catalogConfig?.environmentDetails?.selectedNetworks &&
                item?.catalogConfig?.environmentDetails?.selectedNetworks?.length > 0
            ) {
                orderItemDetails.selectedNetworks = [...orderItemDetails.selectedNetworks, ...item?.catalogConfig?.environmentDetails?.selectedNetworks];
            }
            if (item?.catalogConfig?.environmentDetails) {
                Object.keys(item?.catalogConfig?.environmentDetails)?.forEach((label) => {
                    const excludeEnvFields = [
                        'projectName',
                        'adOu',
                        'domain',
                        'costCenter',
                        'region',
                        'applicationTier',
                        'environment',
                        'landingZoneId',
                        'selectedNetworks',
                        'appTierCode',
                        'costCenter',
                        'frontendPoolName',
                        'backendPoolName',
                        'subscriptionId',
                    ];
                    if (!excludeEnvFields.includes(label)) {
                        const envValue = item?.catalogConfig?.environmentDetails[label];
                        let formattedValue = null;
                        if (Array.isArray(envValue)) {
                            formattedValue = envValue.length > 0 ? envValue.join(', ') : null;
                        } else {
                            formattedValue = envValue ?? null;
                        }
                        orderItemDetails.environmentDetails = {
                            ...orderItemDetails?.environmentDetails,
                            ...(label === 'drPriority' && { 'DR Priority': formattedValue }),
                            ...(label === 'isaDocument' && { 'ISA Document': formattedValue }),
                            ...(label !== 'drPriority' && label !== 'isaDocument' && { [label]: formattedValue }),
                            ...(couchbaseDbDefinitionId.includes(item.catalogServiceCode) &&
                                label === 'asr' && {
                                    asr: envValue === false ? 'disabled' : 'enabled',
                                }),
                        };
                    }
                });
            }
            if (
                item?.catalogConfig?.environmentDetails &&
                [
                    ...ApplicationGateWayURLCatalogDefinitionID,
                    ...InternalApplicationGateWayURLCatalogDefinitionID,
                    ...ExternalPublicLoadBalancerURLCatalogDefinitionID,
                    ...PgtSapSolutionCatalogDefinitionId,
                ].includes(item.catalogServiceCode)
            ) {
                orderItemDetails.environmentDetails = {
                    ...orderItemDetails?.environmentDetails,
                    ...([...ApplicationGateWayURLCatalogDefinitionID].includes(item.catalogServiceCode) && {
                        'Subscription ID': item?.catalogConfig?.environmentDetails?.subscriptionId,
                    }),
                };
            }

            orderItemDetails.environmentDetails = {
                ...orderItemDetails?.environmentDetails,
                ...((linuxVM.includes(item?.catalogServiceCode) ||
                    [...windowsVM, ...pgcsWindowsVmCatalogDefinitionId].includes(item?.catalogServiceCode) ||
                    oracleIaaS.includes(item?.catalogServiceCode) ||
                    sqlIaaS.includes(item?.catalogServiceCode) ||
                    pgcsSqlIaaSCatalogDefinitionId.includes(item?.catalogServiceCode)) && {
                    ...(item?.recoveryVaultName && { recoveryVaultName: item?.recoveryVaultName }),
                    ...(item?.recoveryVaultPolicyName && { recoveryVaultPolicyName: item?.recoveryVaultPolicyName }),
                    ...(item?.recoveryVaultResourceGroup && { recoveryVaultResourceGroup: item?.recoveryVaultResourceGroup }),
                }),
                ...([
                    ...[...AwsEksnCatalogDefinitionId, ...AwsExternalURLOnboardingCatalogDefinitionId, ...AwsMYSQLRDSCatalogDefinitionId],
                    ...AwsLambdaFunctionCatalogDefinitionId,
                    ...PgtSapSolutionCatalogDefinitionId,
                ].includes(item.catalogServiceCode) && {
                    ...item?.catalogConfig?.environmentDetails,
                    ...(AwsLambdaFunctionCatalogDefinitionId.includes(item.catalogServiceCode) &&
                        Array.isArray(item?.catalogConfig?.environmentDetails?.subnetDetails) && {
                            subnetDetails: item?.catalogConfig?.environmentDetails?.subnetDetails.map((s) => s?.name).join(', '),
                        }),
                }),
            };

            orderItemDetails.tags = { ...orderItemDetails?.tags, ...item?.catalogConfig?.tags };

            if (keyvaultCatalogDefinitionId.includes(item?.catalogServiceCode)) {
                delete orderItemDetails.tags.Billingentity;
            }
            if (eipStackCatalogDefinitionId.includes(item?.catalogServiceCode)) {
                orderItemDetails.connections = item?.catalogConfig?.connections;
                orderItemDetails.components = item?.catalogConfig?.components?.map(
                    (component) =>
                        getOrderSummary({
                            orders: { ...component, catalogServices: [{ ...component?.catalogService }] },
                        })?.[0]
                );
                orderItemDetails.environmentDetails = {
                    ...orderItemDetails?.environmentDetails,
                    projectName: item?.catalogConfig?.environmentDetails.projectName,
                };
                orderItemDetails.tags = {
                    ...orderItemDetails?.tags,
                    ...getServiceResourceTags(item?.catalogConfig?.components),
                };
                delete orderItemDetails?.environmentDetails?.applicationManagerEmail;
                delete orderItemDetails?.environmentDetails?.businessService;
            }
            if (couchbaseDbDefinitionId.includes(item?.catalogServiceCode)) {
                orderItemDetails.osType = 'Linux';
                orderItemDetails.instance = {
                    Cluster: item?.catalogConfig?.cluster,
                    'Couchbase DB Version': item?.catalogConfig?.dbVersion,
                    'No. of Servers': item?.catalogConfig?.nodesCount,
                };
                orderItemDetails.components = item?.catalogConfig?.components?.map((component) => {
                    const catalogConfig = component?.catalogService?.catalogConfig;
                    return {
                        'Os Type': `${catalogConfig?.os?.publisher},${catalogConfig?.os?.sku}`,
                        'Vm Type': catalogConfig?.vmType,
                        Domain: catalogConfig?.environmentDetails?.domain,
                        'HA Deployment': catalogConfig?.haDeployment,
                        ...(catalogConfig?.haDeployment === 'Availability Zones' && {
                            'Availability Zones': catalogConfig?.availabilityZones?.toString(),
                        }),
                        'SAM Account': catalogConfig?.samAccountId,
                        'Time Zone': component?.catalogService?.timeZone,
                        'SSL Certificate': catalogConfig?.sslCertificate,
                    };
                });
                orderItemDetails.dataDisks = item?.catalogConfig?.components?.map((component) => ({
                    dataDisk: component?.catalogService?.catalogConfig?.diskDefinitions,
                }));
                orderItemDetails.serviceMappings = item?.catalogConfig?.serviceMappings?.map((mapping) => ({
                    clusterService: mapping?.clusterService,
                    memoryQuota: mapping?.memoryQuota,
                    nodes: mapping?.nodes?.toString(),
                    storagePath: mapping?.storagePath,
                }));
                orderItemDetails.buckets = item?.catalogConfig?.buckets?.map((bucket) => ({
                    BucketType: bucket?.bucketType,
                    BucketMemSize: bucket?.bucketMemSize,
                    BucketNames: bucket?.bucketNames?.toString(),
                }));
            }
            Object.keys(orders?.entityDetails).forEach((label) => {
                if (!['applicationManagerGpid'].includes(label)) {
                    orderItemDetails.applicationDetails = {
                        ...orderItemDetails?.applicationDetails,
                        [label]: orders?.entityDetails[label] || null,
                    };
                }
            });
            if (
                [
                    ...ApplicationGateWayURLCatalogDefinitionID,
                    ...InternalApplicationGateWayURLCatalogDefinitionID,
                    ...ExternalPublicLoadBalancerURLCatalogDefinitionID,
                ].includes(item?.catalogServiceCode) &&
                item?.provisionedDetails &&
                Object.keys(item?.provisionedDetails)?.length > 0
            ) {
                Object.keys(item?.provisionedDetails).forEach((label) => {
                    if (!['applicationManagerGpid'].includes(label)) {
                        orderItemDetails.provisionDetails = {
                            ...orderItemDetails?.provisionDetails,
                            [label]: item?.provisionedDetails[label] || null,
                        };
                    }
                });
            }

            return orderItemDetails;
        });
        return result || [];
    }
    return [];
};
export default getOrderSummary;
